import { AccessLinkRequestForbiddenError } from '../errors/AccessLinkRequestForbiddenError';
import { LinkRequestMustBePendingError } from '../errors/LinkRequestMustBePendingError';
import { FailureReason, FailureReasons } from '../models/LinkRequestStatus';

export function mapErrorToFailureReason(error: Error): FailureReason {
    if (error instanceof LinkRequestMustBePendingError) {
        switch (error.currentState) {
            case 'ACCEPTED':
                return FailureReasons.alreadyAccepted;
            case 'REJECTED':
                return FailureReasons.alreadyRejected;
            default:
                return FailureReasons.unknown;
        }
    }
    if (error instanceof AccessLinkRequestForbiddenError) {
        return FailureReasons.forbidden;
    }
    return FailureReasons.unknown;
}
